import { Component, OnInit } from '@angular/core';
import { SavedFormsService } from '../../../services/saved-forms.service';
import { SavedForm } from '../../../classes/savedForm';
import { Router, NavigationExtras } from '@angular/router';
import { Statique } from '../../../utils/statique';
import { SavedFormIdentifier } from '../../../utils/enumeration';
import { ConnectedUserComponent } from '../../../shared/connectedUserComponent';
import { EbUser } from '../../../classes/user';
import { ModalService } from '../../../shared/modal/modal.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-saved-search',
	templateUrl: './saved-search.component.html',
	styleUrls: ['./saved-search.component.css']
})
export class SavedSearchComponent extends ConnectedUserComponent implements OnInit {

	protected ebCompNum: number;
	listSavedForm: SavedForm[];
	selectedSavedForm: SavedForm;
	activeSf: number;
	subscriptions: Array<Subscription> = new Array<Subscription>();
	savedForm: SavedForm;

	constructor(
		protected savedFormsService: SavedFormsService,
		protected router: Router,
		protected modalService: ModalService
	) {
		super();

		this.ebCompNum = SavedFormIdentifier.SAVED_SEARCH;
	}

	ngOnInit() {
		this.activeSf = 0;
		this.savedForm = new SavedForm();
		this.savedForm.ebCompNum = this.ebCompNum;
		this.savedForm.ebUserNum = this.ebUserNum;
		this.loadSavedForm({
			ebCompNum: this.ebCompNum,
			ebUserNum: this.userConnected ? this.userConnected.ebUserNum : null
		});
		this.subscriptions.push(this.savedFormsService.SavedFormsObservale.subscribe((res: SavedForm) => {
			if (this.ebCompNum == res.ebCompNum)
				this.loadSavedForm(this.savedForm);

		}));

	}

	deleteSavedForm(sf: SavedForm, index: number) {
		this.modalService.confirm('Confirm deleting', 'Are you sure you want to delete this element?', function () {
			this.savedFormsService.deleteSavedForm(sf).subscribe();
			this.listSavedForm.splice(index, 1);
		}.bind(this), () => { });
	}

	navigateToComponentTarget(sf: SavedForm) {
		let path = null;
		if (sf.url)
			path = sf.url;
		else
			path = "app/" + Statique.getComponentPathByCompIdAndModuleId(sf.ebCompNum, sf.ebModuleNum);

		let navigationExtras: NavigationExtras = {
			queryParams: {
				ebCompNum: sf.ebCompNum,
				ebModuleNum: sf.ebModuleNum,
				ebSavedFormNum: sf.ebSavedFormNum,
				ebUserNum: sf.ebUserNum,
				formName: sf.formName,
				formValues: sf.formValues,
				url: sf.url
			}
		};

		if (!this.router.isActive(path, true))
			this.router.navigate([path], navigationExtras);
	}

	sendSavedForm(sf: SavedForm) {
		// design active element in the saved-form list in order to highlight it
		this.activeSf = sf.ebSavedFormNum;

		// navigate to target component/page
		this.navigateToComponentTarget(sf);

		if (sf.ebCompNum == SavedFormIdentifier.SAVED_SEARCH) {
			// send data to the target component
			let event = new CustomEvent('savedsearch', { detail: sf });
			document.dispatchEvent(event);
		} else {
			// send data to the target component			
			this.savedFormsService.emitSavedForm(sf);
		}
	}

	loadSavedForm(sf) {
		return this.savedFormsService.getSavedForms(sf).subscribe(res => this.listSavedForm = res);
	}

	getModuleIcon(ebModuleNum): string {
		let moduleName: string = Statique.getModuleNameByModuleNum(ebModuleNum);

		if (!moduleName)
			return null;

		return Statique.iconsPath + Statique.moduleIcon[moduleName];

	}
	isIconDefined(ebModuleNum): boolean {
		return Statique.isDefined(this.getModuleIcon(ebModuleNum));
	}

}



// WEBPACK FOOTER //
// ./src/app/component/saved-forms/saved-search/saved-search.component.ts